import React from 'react';
import Select from 'react-select';

const options = [
    {value: 'ALL', label: 'Все категории'},
    {value: 'DIVINE_SERVICE', label: 'Богослужение'},
    {value: 'SUNDAY_SCHOOL', label: 'Воскресная школа'},
    {value: 'YOUTH_MINISTRY', label: 'Молодёжное служение'},
    {value: 'CHURCH_EVENTS', label: 'Церковные мероприятия'},
    {value: 'CONFERENCE_EVENTS', label: 'Конференции'},
    {value: 'TRIPS', label: 'Поездки'},
    {value: 'MISSION', label: 'Миссия'}

];

const createOptions = [
    {value: 'DIVINE_SERVICE', label: 'Богослужение'},
    {value: 'SUNDAY_SCHOOL', label: 'Воскресная школа'},
    {value: 'YOUTH_MINISTRY', label: 'Молодёжное служение'},
    {value: 'CHURCH_EVENTS', label: 'Церковные мероприятия'},
    {value: 'CONFERENCE_EVENTS', label: 'Конференции'},
    {value: 'TRIPS', label: 'Поездки'},
    {value: 'MISSION', label: 'Миссия'}

];

const defaultArchiveSelectValue = options[0];
const defaultArchiveSelectCreateValue = options[1];

// Тема-зависимые стили react-select (var(--*) резолвятся из :root / [data-theme])
const selectStyles = {
    control: (base, state) => ({
        ...base,
        backgroundColor: 'var(--surface)',
        borderColor: state.isFocused ? 'var(--accent)' : 'var(--border)',
        boxShadow: 'none',
        '&:hover': {borderColor: 'var(--accent)'},
    }),
    menu: (base) => ({
        ...base,
        backgroundColor: 'var(--surface)',
        border: '1px solid var(--border)',
        zIndex: 20,
    }),
    option: (base, state) => ({
        ...base,
        backgroundColor: state.isSelected
            ? 'var(--accent)'
            : state.isFocused
                ? 'var(--surface-2)'
                : 'var(--surface)',
        color: state.isSelected ? 'var(--accent-contrast)' : 'var(--text)',
        cursor: 'pointer',
    }),
    singleValue: (base) => ({...base, color: 'var(--text)'}),
    placeholder: (base) => ({...base, color: 'var(--text-muted)'}),
    input: (base) => ({...base, color: 'var(--text)'}),
    dropdownIndicator: (base) => ({...base, color: 'var(--text-muted)'}),
    indicatorSeparator: (base) => ({...base, backgroundColor: 'var(--border)'}),
};

const ArchiveSelect = ({value, handleChange, create, search}) => {
    return (
        <div className="w-100">
            <Select
                isSearchable={search || false}
                options={create ? createOptions : options}
                value={value}
                onChange={handleChange}
                placeholder="Выберите категорию"
                styles={selectStyles}
            />
        </div>
    );
};

export {ArchiveSelect, defaultArchiveSelectValue, defaultArchiveSelectCreateValue};
